import { render, staticRenderFns } from "./WordShorthand.vue?vue&type=template&id=54ef53fd&scoped=true&"
import script from "./WordShorthand.vue?vue&type=script&lang=js&"
export * from "./WordShorthand.vue?vue&type=script&lang=js&"
import style0 from "./WordShorthand.vue?vue&type=style&index=0&id=54ef53fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef53fd",
  null
  
)

export default component.exports